import { SURVEY_EVENTS, SURVEY_COMMENT, SURVEY_RATING } from "../reducers/survey-reducer";
import surveyService from "../services/surveyService";
import CustomToast from "../components/UI/customToast";
import { dehydrateSurveyComment, dehydrateSurveyRating } from "../transformers/surveyTransformer";
import { dispatchAction } from "../shared/function";

//#region Survey Rating
const surveyRattingStart = () => dispatchAction(SURVEY_EVENTS.SURVEY_RATING, SURVEY_RATING.START);
const surveyRattingSuccess = (data) => dispatchAction(SURVEY_EVENTS.SURVEY_RATING, SURVEY_RATING.SUCCESS, data);
const surveyRattingError = (error) => dispatchAction(SURVEY_EVENTS.SURVEY_RATING, SURVEY_RATING.ERROR, error);

export const putSurveyRating = (req) => async (dispatch) => {
    dispatch(surveyRattingStart());
    surveyService
        .putRating(dehydrateSurveyRating(req))
        .then((response) => {
            dispatch(surveyRattingSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(surveyRattingError(error));
        });
};
//#endregion

//#region Survey Comment
const surveyCommentStart = () => dispatchAction(SURVEY_EVENTS.SURVEY_COMMENT, SURVEY_COMMENT.START);
const surveyCommentSuccess = (data) => dispatchAction(SURVEY_EVENTS.SURVEY_COMMENT, SURVEY_COMMENT.SUCCESS, data);
const surveyCommentError = (error) => dispatchAction(SURVEY_EVENTS.SURVEY_COMMENT, SURVEY_COMMENT.ERROR, error);

export const putSurveyComment = (req) => async (dispatch) => {
    dispatch(surveyCommentStart());
    surveyService
        .putComment(dehydrateSurveyComment(req))
        .then((response) => {
            dispatch(surveyCommentSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(surveyCommentError(error));
        });
};
//#endregion
